import { Table, Tooltip } from 'antd'
import dayjs from 'dayjs'
import React from 'react'

import type { NomiStatusFileDetail } from '../types'

interface NomiStatusFileTooltipProps {
  sourceFilesDetails: NomiStatusFileDetail[]
  children: React.ReactElement
}

export function NomiStatusFileTooltip({
  sourceFilesDetails,
  children
}: NomiStatusFileTooltipProps) {
  const columns = [
    {
      title: 'File',
      dataIndex: 'source_file_name',
      key: 'source_file_name',
      width: 160,
      render: (value: string) => (
        <div className='truncate text-xs' title={value}>
          {value}
        </div>
      )
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 80,
      render: (value: string) => <div className='text-xs'>{value}</div>
    },
    {
      title: 'Exception',
      dataIndex: 'exception_type',
      key: 'exception_type',
      width: 90,
      render: (value: string) => <div className='text-xs'>{value || '-'}</div>
    },
    {
      title: 'Time',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 100,
      render: (value: string) => {
        if (!value) return <div className='text-xs'>-</div>
        return <div className='text-xs'>{dayjs(value).format('MM/DD HH:mm')}</div>
      }
    }
  ]

  const tooltipContent = (
    <div style={{ maxWidth: '750px' }}>
      <div className='mb-1 font-semibold text-sm'>
        Status Report ({sourceFilesDetails.length} files)
      </div>
      <div
        style={
          {
            '--ant-table-padding-vertical': '2px',
            '--ant-table-padding-horizontal': '6px',
            '--ant-table-header-height': '28px'
          } as React.CSSProperties
        }
      >
        <Table
          dataSource={sourceFilesDetails}
          columns={columns}
          pagination={false}
          size='small'
          rowKey={(record, index) => `${record.source_file_name}-${index}`}
          scroll={{ x: 700 }}
          className='status-files-table'
          style={{
            fontSize: '11px'
          }}
          components={{
            body: {
              row: (props: { style: React.CSSProperties }) => (
                <tr {...props} style={{ height: '20px', ...props.style }} />
              ),
              cell: (props: { style: React.CSSProperties }) => (
                <td
                  {...props}
                  style={{
                    padding: '1px 6px',
                    lineHeight: '1.1',
                    height: '20px',
                    ...props.style
                  }}
                />
              )
            },
            header: {
              cell: (props: { style: React.CSSProperties }) => (
                <th
                  {...props}
                  style={{
                    padding: '2px 6px',
                    lineHeight: '1.1',
                    height: '24px',
                    ...props.style
                  }}
                />
              )
            }
          }}
        />
      </div>
    </div>
  )

  return (
    <Tooltip
      title={tooltipContent}
      color='#ffffff'
      styles={{
        root: {
          maxWidth: '800px'
        }
      }}
      placement='bottomLeft'
      trigger='hover'
    >
      {children}
    </Tooltip>
  )
}
